import React, { FC } from 'react';

import { UserSuppliesRows } from '../UserSuppliesRows';
import { useUserSuppliesData } from '../../hooks/useUserSuppliesData';
import { useFetchUserSupplies } from '../../hooks/useFetchUserSupplies';

import { EmptyBanner } from '@/widgets/Banners/EmptyBanner';
import { ConnectWalletBanner } from '@/widgets/Banners';
import { ServerError } from '@/widgets/ServerError';
import { useHasSupplyError } from '@/shared/hooks/useErrors';
import { getUsersSupplies } from '@/shared/store/supplies/actions';

export const UserSuppliesSection: FC = () => {
    const { walletAddress, blockchainName, loading, userSupplies, hasUserSupplies, agreements } =
        useUserSuppliesData();

    useFetchUserSupplies(walletAddress, blockchainName, agreements);

    const hasError = useHasSupplyError();

    const getContent = () => {
        if (!walletAddress) {
            return <ConnectWalletBanner />;
        }

        const notLoading = !loading && !userSupplies.length;
        const userDontHaveSupplies = loading && !hasUserSupplies;
        if (notLoading || userDontHaveSupplies) {
            return <EmptyBanner />;
        }

        return (
            <div className='overflow-x-auto [&_th]:font-semibold'>
                <table className='border-collapse w-full bg-primary border border-opaque min-w-[950px]'>
                    <thead>
                        <tr
                            className='border-b border-opaque h-[52px] 
                                        [&_span]:font-semibold 
                                        [&>th]:font-semibold [&>th]:text-left [&>th]:text-primary [&>th]:w-[20%] [&>th]:bg-background-secondary 
                                        [&>th:last-child]:text-right 
                                        [&>td:last-child]:pr-7 [&>th:last-child]:pr-7 
                                        [&>th:first-child]:pl-6 [&>td:first-child]:pl-6'
                        >
                            <th>Pools</th>
                            <th>Asset</th>
                            <th>Supply APY</th>
                            <th>Your position</th>
                            <th>Total Profit</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody data-testid='user-supplies-table'>
                        <UserSuppliesRows items={userSupplies} />
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <div className='w-full text-primary mt-[52px]'>
            <div className='text-lg pb-6 pl-5 font-semibold'>Your Supplies</div>
            {hasError ? <ServerError action={getUsersSupplies} /> : getContent()}
        </div>
    );
};
